<template>
  <base-container>
    <el-form
      disabled
      ref="adForm"
      :model="formData"
      :rules="rules"
      size="medium"
      label-width="100px"
    >
      <el-form-item label="公告标题" prop="title">
        <el-input
          v-model="formData.title"
          placeholder="请输入公告标题"
          show-word-limit
          clearable
          maxlength="100"
          :style="{ width: '100%' }"
        />
      </el-form-item>
      <el-form-item label="展示图片" prop="displayImg" required>
        <single-upload
          v-model="formData.picUrl"
          upload-tip="(656px*360px) 支持jpg/png/jpeg格式"
        />
      </el-form-item>
      <el-form-item label="概述" prop="summary">
        <el-input
          v-model="formData.summary"
          type="textarea"
          placeholder="请输入概述"
          show-word-limit
          maxlength="250"
          :autosize="{ minRows: 4, maxRows: 4 }"
          :style="{ width: '100%' }"
        />
      </el-form-item>
      <el-form-item label="点击效果" prop="showType">
        <el-radio-group v-model="formData.showType" size="medium">
          <el-radio
            v-for="(item, index) in showTypeOptions"
            :key="index"
            border
            :label="item.value"
            >{{ item.label }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item v-show="formData.showType == 2" label="跳转连接" prop="link">
        <el-input
          v-model="formData.link"
          placeholder="请输入跳转连接"
          clearable
          :style="{ width: '100%' }"
        />
      </el-form-item>
      <el-form-item
        v-show="formData.showType === 3"
        label="富文本"
        prop="richtext"
      >
        <tinymce v-model="formData.richtext" />
      </el-form-item>
      <el-form-item size="large">
        <el-button type="primary" class="mr8" @click="submitForm">提交</el-button>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>
  </base-container>
</template>
<script>
import Tinymce  from "@/components/Tinymce"
import { addOrUpdateAnnounce, getAnnounceInfo } from "@/api/announce";
import singleUpload from "@/components/upload/singleUpload";
export default {
  name: "AnnounceAdd",
  components: {
    singleUpload,
    Tinymce
  },
  props: [],
  mounted() {
    this.initData();
  },
  data() {
    return {
      formData: {
        id: null,
        title: "",
        picUrl: "",
        summary: "",
        showType: 1,
        link: "",
        richtext: "",
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入公告标题",
            trigger: "blur",
          },
        ],
        summary: [
          {
            required: true,
            message: "请输入概述",
            trigger: "blur",
          },
        ],
        showType: [
          {
            required: true,
            message: "请选择点击效果",
            trigger: "change",
          },
        ],
        link: [
          {
            type: "url",
            message: "跳转连接不合法",
            whitespace: true,
            trigger: ["blur", "change"],
          },
        ],
        richtext: [
          {
            type: "String",
            message: "富文本不能为空",
            min: 0,
            whitespace: true,
            trigger: ["blur", "change"],
          },
        ],
      },
      showTypeOptions: [
        {
          label: "无效果",
          value: 1,
        },
        {
          label: "跳转连接",
          value: 2,
        },
        {
          label: "富文本",
          value: 3,
        },
      ],
    };
  },
  methods: {
    initData() {
      const { id } = this.$route.query;
      if (id) {
        getAnnounceInfo({ id }).then((res) => {
          this.formData = res.data;
        });
      }
    },
    submitForm() {
      this.$refs["adForm"].validate((valid) => {
        if (!valid) return;
        // TODO 提交表单
        addOrUpdateAnnounce(this.formData).then((res) => {
          this.$router.push({
            path: "/content/announce/list",
          });
        });
      });
    },
    resetForm() {
      this.$refs["adForm"].resetFields();
    }
  }
}
</script>
<style>
.el-upload__tip {
  line-height: 1.2;
}
</style>

